//! TEST CLIENTS
export const environment = {
  production: false,
  environment: 'acc',
  devMode: false,
  currentVersion: '3.1.3',
  issuer: 'https://sts.inforius.be',
  postLogoutRedirectUri: 'https://idelibe-acc-gpl.myinforius.be',
  redirectUri: 'https://idelibe-acc-gpl.myinforius.be/callback',
  clientId: 'idelback_e3_accnew',
  oidc: true,
  userinfoEndpoint: 'https://sts.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope:
    'openid profile email idelback.e3_accnew_f iadm.e3_accnew_f icont.e3_accnew_idelback_f itemplate.api icont.e3_accnew_iadm_f iaddress.api iscan.api_e3',
  showDebugInformation: false,
  silentRefreshRedirectUri: 'https://idelibe-acc-gpl.myinforius.be/silent-renew.html',
  responseType: 'code',
  requireHttps: true,
  baseUrl: 'https://idelibe-acc-gpl.myinforius.be',
  apiGatewayBaseUrl: 'https://idelibeapigw-acc-gpl.myinforius.be/iDelibe',
  apiICourrierBaseUrl: 'https://icourrierapigw-acc-gpl.myinforius.be/iCourriers/api/v2',
  apiIAdminBaseUrl: 'https://iadmapigw-acc-gpl.myinforius.be/iAdm',
  apiIContactBaseUrl: 'https://idelibeapigw-acc-gpl.myinforius.be/iContactsDelibe/api',
  apiIContactBaseUrlAdmin: 'https://iadmapigw-acc-gpl.myinforius.be/iContactsAdm',
  frontIAdminUrl: 'https://iadm-acc-gpl.myinforius.be',
  frontICourrierUrl: 'https://icourrier-acc-gpl.myinforius.be',
  baseUrlDocumentEditor: 'https://iadmapigw-acc-gpl.myinforius.be/iTemplate/api/v2/',
  iAddressBaseUrl: 'https://iaddressapi-prod.azurewebsites.net/api/v1',
  showDocExportBtn: false,
  enableSpellCheck: false,
  enableLogConsole: true,
  apiIscanBaseUrl: 'https://api-iscan.myinforius.be',
  ssoIscanUrl: 'https://sts.inforius.be',
  iScanUrl: 'https://api-iscan.myinforius.be',
  iScanCallbackToIdelibe: '/api/v1/Connecteurs/IScan/Status',
  adobeClientId: 'dd01431198d3440080818b7db64330ad',
  apiRoots: [
    'https://idelibe2nd-test.myinforius.be',
    'https://idelibe2ndapigw-test.myinforius.be/iDelibe',
    'https://icourrier2ndapigw-test.myinforius.be/iCourriers/api/v2',
    'https://iadm2ndapigw-test.myinforius.be/iAdm',
    'https://idelibe2ndapigw-test.myinforius.be/iContactsDelibe/api',
    'https://iadm2ndapigw-test.myinforius.be/iContactsAdm',
    'https://iadm2nd-test.myinforius.be',
    'https://icourrier2nd-test.myinforius.be',
    'https://iadm2ndapigw-test.myinforius.be/iTemplate/api/v2/',
    'https://iaddressapi-acc.azurewebsites.net/api/v1',
    'https://api-acc-iscan.myinforius.be',
    'https://iadmapigw-acc-gpl.myinforius.be',
    'https://idelibeapigw-acc-gpl.myinforius.be',
  ],
};
